import React, { useState } from 'react';
import Button from '@mui/joy/Button';
import type { ButtonProps } from '@mui/joy/Button';
import { ArrowSquareOut as OpenInNewIcon } from '@phosphor-icons/react';
import CircularProgress from '@mui/joy/CircularProgress';
import api from '../../lib/api';

interface PreviewSiteButtonProps extends ButtonProps {
  siteId: number | string;
  domain?: string;
  isActive?: boolean;
}

const PreviewSiteButton: React.FC<PreviewSiteButtonProps> = ({
  siteId,
  domain,
  isActive = true,
  children,
  ...props
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      // Request a signed preview URL from the backend
      const response = await api.get<{ preview_url: string }>(`/api/cms/sites/${siteId}/generate-preview-url/`);
      const { preview_url } = response.data;
      window.open(preview_url, '_blank', 'noopener');
    } catch (error) {
      console.error('Failed to generate preview URL:', error);
      // Fallback: still try to open, but it will likely fail
      window.open(`/cms/sites/preview/`, '_blank', 'noopener');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      {...props}
      onClick={handleClick}
      startDecorator={loading ? <CircularProgress size="sm" /> : <OpenInNewIcon />}
      disabled={loading || props.disabled}
    >
      {children || 'Preview Site'}
    </Button>
  );
};

export default PreviewSiteButton;
